import type { PaginationState } from '@tanstack/table-core';

export const balanceKeys = {
  usersBalance: ['users-balance'],
  promocodes: ['promocodes'],
  recurrentPayment: ['recurrent-payment'],
  balanceDetails: ['balance-details'],
  balanceDetailsType: (type: 'details' | 'payments') => [
    ...balanceKeys.balanceDetails,
    type,
  ],
  balanceWithPagesAndSize: (
    type: 'details' | 'payments',
    pagination: PaginationState
  ) => [...balanceKeys.balanceDetailsType(type), pagination],
};

export const infiniteBalanceKeys = {};
